import {
  Checkbox, TableCell, TableHead, TableRow, TableSortLabel 
} from '@mui/material';
import React, { useCallback } from 'react';

import { toSnakeCase, toTitle } from '../utils';

interface HeaderProps {
  columnProps: any;
  handleSort: (a: any) => void;
  multiSelect: boolean;
  selectable: boolean;
  selected: any; // TODO: find out type
  sortable: boolean;
  sortColumn: string;
  sortDirection?: 'desc' | 'asc';
}

interface HeaderCellContentProps {
  columnConfig: any;
  handleSort: (a: any) => void;
  sortable: boolean;
  sortColumn: string;
  sortDirection?: 'desc' | 'asc';
}

const Header = React.memo(function Header({
  columnProps,
  handleSort,
  multiSelect,
  selectable,
  selected,
  sortable,
  sortColumn,
  sortDirection
}: HeaderProps) {
  return (
    <TableHead>
      <TableRow>
        { selectable && multiSelect && (
          <TableCell>
            <Checkbox checked={selected.ALL || false} data-action="select" value="ALL" />
          </TableCell>
        ) }
        { selectable && !multiSelect && <TableCell /> }
        { columnProps
          .filter((p) => p.indexView)
          .map((columnConfig, idx) => {
            return (
              <TableCell key={idx}>
                <HeaderCellContent
                  columnConfig={columnConfig}
                  handleSort={handleSort}
                  sortable={sortable}
                  sortColumn={sortColumn}
                  sortDirection={sortDirection}
                />
              </TableCell>
            );
          }) }
      </TableRow>
    </TableHead>
  );
});

const HeaderCellContent = React.memo(function HeaderCellContents({
  columnConfig,
  handleSort,
  sortable,
  sortColumn,
  sortDirection
}: HeaderCellContentProps) {
  // TODO: change column to column name
  const column = columnConfig.columnName || toSnakeCase(columnConfig.key);
  const label = columnConfig.label || toTitle(columnConfig.key);

  const sortHandler = useCallback(
    function sortHandler() {
      handleSort({
        sortColumn: column,
        sortDirection: sortDirection === 'desc' ? 'asc' : 'desc'
      });
    },
    [ column, handleSort, sortDirection ]
  );

  if (sortable)
    return (
      <TableSortLabel
        active={sortColumn === column}
        direction={sortDirection}
        onClick={sortHandler}
      >
        { label }
      </TableSortLabel>
    );

  return label;
});

export default Header;
